// extracted by mini-css-extract-plugin
export default {"container":"vj-z","links":"wj-z"};